import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Component
import SessionHandler from '../../contactUs/containers/SessionHandler';
import HeroModuleSession from '../../contactUs/containers/HeroModule';
import ContactOptionsLinksFooter from '../../contactUs/components/ContactOptionsLinksFooter';
import AlertsContainer from '../../contactUs/containers/Alerts';

// Container
import NavHome from '../containers/NavHome';

// Helper
import Page from '../../lib/page';

const isMobileLayout = Page.isMobileLayout();

const App = (props) => {
  // Update MainContainer class for mobile layout
  function getMainContainerClass() {
    return classNames({
      'main-container col-lg-9 col-md-9 col-sm-8': true,
      'mobile-main-container': isMobileLayout,
    });
  }

  const { sideBar, mainContainer } = props;

  const sidebarEl = (
    <div className="side-bar col-lg-3 col-md-3 col-sm-4">
      { sideBar }
    </div>
  );

  const mainContainerEl = (
    <div id="main-container" className={getMainContainerClass()} tabIndex="0" aria-label="">
      <div className="main-container-contents">
        { mainContainer }
      </div>
    </div>
  );

  return (
    <div className="vx_mainContent">
      <SessionHandler />
      <HeroModuleSession />
      <AlertsContainer />
      <NavHome />
      <div className="page-body-container">
        <div className="row">
          {sidebarEl} {mainContainerEl}
        </div>
      </div>
      <ContactOptionsLinksFooter />
    </div>
  );
};

App.propTypes = {
  sideBar: PropTypes.element.isRequired,
  mainContainer: PropTypes.element.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./home/components/HelpApp.js